module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Stephanie Layman-0bd8af572c8425f6ad836f5b652e194c.jpg";